import { render, staticRenderFns } from "./FinalDocumentList.vue?vue&type=template&id=79e6efe4&"
import script from "./FinalDocumentList.vue?vue&type=script&lang=ts&"
export * from "./FinalDocumentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports